<template>
	<div>
		<div class="more-width">
			<div class="platfor-image">
				<div style="padding-top: 30px; margin-left: 13px; font-size: 22px">回收流程</div>
			</div>
			<div class="more-text">选择京卡收 安全有保障</div>
			<div class="flex-more">
				<div>
					<img src="../assets/login-account/Group 951@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>完成实名认证</div>
				</div>
				<div>
					<img src="../assets/login-account/Group 951@2x(1).png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>等待平台认证</div>
				</div>
				<div>
					<img src="../assets/login-account/Group 951@2x(2).png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>相应资金到账</div>
				</div>
				<div>
					<img src="../assets/login-account/Group 1214@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>绑定提现账号</div>
				</div>
				<div>
					<img src="../assets/login-account/Group 1215@2x.png" class="images" />
				</div>
				<div class="hot-group">
					<div class="hot-slices"></div>
					<div>银行或支付宝</div>
				</div>
				<div>
					<img src="../assets/login-account/Group 951@2x(3).png" class="images" />
				</div>
			</div>
		</div>
	</div>
</template>

<script></script>

<style scoped lang="scss">
.more-width {
	width: 1280px;
	padding-top: 41px;
	padding-bottom: 45px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	margin: auto;
	margin-top: 50px;
}
.more-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
}
.flex-more {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-left: 44px;
	margin-top: 30px;
}
.more-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	margin-top: 6px;
	text-transform: none;
}
.hot-group {
	white-space: nowrap;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 11px;
	color: #000000;
	font-style: normal;
	text-transform: none;
	padding-bottom: 7px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: -10px;
}
.hot-slices {
	margin: auto;
	width: 50px;
	height: 0px;
	border-top: 2px solid #eeeeee;
	padding-top: 10px;
}

.images {
	width: 85%;
	height: auto;
}

.flex-right {
	display: flex;
}

.userName {
	width: 65px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	line-height: 16px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-left: 7px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.arrowDown {
	width: 12px;
	height: 12px;
	background: #eeeeee;
	border-radius: 40px;
	border: 1px solid #eeeeee;
	line-height: 12px;
	text-align: center;
}
.center {
	position: relative;
	width: 116px;
	height: 94px;
	background: rgba(51, 51, 51, 0.9);
	border-radius: 0px 0px 0px 0px;
	margin-left: auto;
	margin-right: 100px;
	margin-top: 25px;
}
.center:hover {
	cursor: pointer;
}

.platfor-image {
	background: url('../assets/HomeView/Group 1784@2x.png') no-repeat;
	background-size: cover;
	width: 143px;
	height: 71px;
	margin: auto;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 26px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
}

.platfor-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
}

.list-width {
	width: 1280px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	margin-top: 70px;
}
.list-flex {
	display: flex;
	flex-direction: column;
	align-items: center;

	.title-width {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #222222;
		font-style: normal;
		text-transform: none;
		margin-top: 28px;
	}
	.text-width {
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: rgba(34, 34, 34, 0.7);
		text-align: left;
		font-style: normal;
		text-transform: none;
		margin-top: 4px;
	}
}

.list-const {
	width: 630px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
}

.list-bacgrand {
	padding: 22px;
}

.list-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: -4px;
	margin-left: 7px;
}
.list-text {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ff2f17;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: -4px;
	margin-right: 8px;
}

.flex-asstes-left {
	display: flex;
	align-items: center;
}

.flex-asstes-left-group {
	display: flex;
	align-items: center;
}

.flex-asstes-left-group:hover {
	cursor: pointer;
}

.list-right-asstes {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.border-botton {
	width: 586px;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 12px;
	padding-top: 16px;
}

.red-dot {
	width: 5px;
	height: 5px;
	background: #ff3333;
	border-radius: 0px 0px 0px 0px;
}

.flex-homeView {
	display: flex;
	justify-content: space-between;
}

.flex-homeView:hover {
	cursor: pointer;
}

.date-homeView {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}

.flex-red-dot {
	display: flex;
	align-items: center;
}
.titel-red-dot {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	margin-left: 13px;
	font-style: normal;
	text-transform: none;
}

.titel-red-dot:hover {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 18px;
	color: #ff3333;
	font-style: normal;
	text-transform: none;
	cursor: pointer;
}
</style>
